import React, { useEffect, useState, useRef } from "react";
import { createRoot } from 'react-dom/client';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Modal from 'react-modal'
import Select, { Options } from 'react-select'
import TextField from '@mui/material/TextField';
import {
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    FormLabel,
    Button,
    Grid,
    Box,
    Alert,
    Backdrop,
    CircularProgress
}  from '@mui/material';
import { assertPointResponseOk, runPointRequest } from "./pointRequest";

const theme = createTheme({
    components: {
        MuiTypography: {
            styleOverrides: {
                root: {
                    fontSize: "1.5rem"
                },
            }
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    fontSize: "1.5rem"
                },
            }
        }
    }
});

Modal.setAppElement("#app");

const PointDonation: React.FC = () => {
    let subtitle: HTMLHeadingElement | null
    const [isBlocking, setIsBlocking]           = useState<boolean>(false);
    const [errorMessage, setErrorMessage]       = useState<string>(null);
    const [supportGroup, setSupportGroup]       = useState<string>(null);
    const [supportPoint, setSupportPoint]       = useState<string>('0');
    const [stepNumber, setStepNumber]           = useState<number>(1);
    const [stepNumber1, setStepNumber1]         = useState<boolean>(true);
    const [stepNumber2, setStepNumber2]         = useState<boolean>(false);
    const [stepNumber3, setStepNumber3]         = useState<boolean>(false);
    const [modalIsOpen, setIsOpen]              = React.useState(false);
    const [pointTypeValue, setPointTypeValue]   = React.useState('manual');

    const [readOnlyInputSupportPoint, setReadOnlyInputSupportPoint]
        = useState<boolean>(false);
    const [inputSupportPoint, setInputSupportPoint]
        = useState<string>('0');

    // テキストフィールドの値がチェンジされた時
    const handleInputSupportPointChange = (e) => {
        setInputSupportPoint(e.target.value);
    };

    const handlePointTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = (event.target as HTMLInputElement).value
        switch (value) {
            case 'all':
                // #user-status-amount は Intl.NumberFormat でカンマ整形された値("1,234")のため
                // 数字以外を除去してから渡す（parseInt がカンマで切れて誤判定するのを防ぐ・課題ID200同型）。
                setInputSupportPoint(document.getElementById("user-status-amount").innerText.replace(/[^0-9]/g, ''));
                setReadOnlyInputSupportPoint(true);
                break;
            default:
                setReadOnlyInputSupportPoint(false);
                break;
        }
        setPointTypeValue(value);
    };

    const customStyles = {
        overlay: {
            zIndex: 100
        },
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            background: 'initial',
            padding: 'initial',
            border: 'none'
        },
    };

    function initialize() {
    }

    useEffect(() => {
        initialize()
    }, []);

    function openModal() {
        setSupportPoint(inputSupportPoint);
        setIsOpen(true);
    }

    function afterOpenModal() {
        // references are now sync'd and can be accessed.
    }

    function closeModal() {
        setIsOpen(false);
    }

    function updateStepNumber(setNumber: number) {
        const newStepNumber = setNumber;
        setStepNumber(newStepNumber);
        switch (newStepNumber) {
            case 1:
                setStepNumber1(true);
                setStepNumber2(false);
                setStepNumber3(false);
                break;
            case 2:
                setStepNumber1(true);
                setStepNumber2(true);
                setStepNumber3(false);
                break;
            case 3:
                setStepNumber1(true);
                setStepNumber2(true);
                setStepNumber3(true);
                break;
        }
    }

    function goToStep1() {
        updateStepNumber(1);
    }

    function goToStep2() {
        if (validationSupportGroup()) {
            setErrorMessage(null);
            updateStepNumber(2);
        }
    }

    function goToStep3() {
        if (validationInputPoint()) {
            setErrorMessage(null);
            setSupportPoint(inputSupportPoint);
            updateStepNumber(3);
        }
    }

    function goToStep4() {
        updateStepNumber(4);
    }

    function validationSupportGroup(): boolean {
        let result  = true;
        if (supportGroup == null) {
            result  = false;
            setErrorMessage("支援・寄付先が選択されていません。");
        }

        return result;
    }

    function validationInputPoint(): boolean {
        let result                  = true;
        let checkInputSupportPoint  = null;
        // 残高はカンマ整形値("1,234")のため数値化して比較する。課題ID200:
        // 文字列<数値の比較は Number("1,234")=NaN→常に false で残高上限チェックがすり抜けるため。
        const pointStatusAmount     = parseInt(document.getElementById("user-status-amount").innerText.replace(/[^0-9]/g, ''), 10);
        try  {
            checkInputSupportPoint  = parseInt(inputSupportPoint);
        } catch (e) {
            result = false;
            setErrorMessage("有効なポイント数を入力してください。");
        }
        switch (true) {
            case isNaN(checkInputSupportPoint):
            case checkInputSupportPoint <= 0:
            case pointStatusAmount < checkInputSupportPoint:
                result = false;
                setErrorMessage("有効なポイント数を入力してください。");
                break;
        }

        return result;
    }

    function getSupportGroup() {
        const supportGroupList = document.getElementById("support_group_list");
        const supportGroupListArray = JSON.parse(supportGroupList.dataset.support_group_list);

        const Options = [];
        supportGroupListArray.forEach(function(element, index, array){
            Options.push({
                label: element,
                value: element
            });
        });

        return Options;
    }

    function ErrorBlock() {
        return (
            <React.Fragment>
                { errorMessage && <Alert className="point-error-message" variant="outlined" severity="error">{ errorMessage }</Alert> }
            </React.Fragment>
        )
    }

    const ErrorModal = () => {
        <Modal
            isOpen={modalIsOpen}
            onAfterOpen={afterOpenModal}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="確認"
        >
            <div className="point-donation-card">
                <h2 ref={(_subtitle) => (subtitle = _subtitle)}>内容のご確認</h2>
                <SupportStatusBlock />
                <button className="donation" onClick={executeDonation}>
                    支援・寄付を確定する
                </button>
                <button onClick={closeModal}>戻る</button>
            </div>
        </Modal>
    }

    function SupportStatusBlock() {
        return (
            <div className="point-donation-card">
                <div className="center">
                    支援・寄付先: <span className="point-donation-card-value">{ supportGroup ?? '未選択' }</span>
                </div>
                <div className="center">
                    支援・寄付ポイント: <span className="point-donation-card-value">{ supportPoint }</span> ポイント
                </div>
            </div>
        )
    }

    function handleChangeSupportGroup(e) {
        setSupportGroup(e.value);
    }

    const requestDonation = async () => {
        const body  = new FormData()
        body.append("support_group", supportGroup)
        body.append("point", supportPoint)

        const url     = '/apps/kuradashi_point/donation/point/';
        const response = await fetch(
            url,
            {
                method: "POST",
                headers: {
                    accept: "application/json, text/plain, */*"
                },
                credentials: 'include',
                body: body,
            }
        );
        await assertPointResponseOk(response);

        return await response.json();
    }

    const executeDonation = () => runPointRequest(async () => {
        await requestDonation();
        goToStep4();
    }, { setErrorMessage, setIsBlocking });

    const options   = getSupportGroup();
    const thanksImageUrlElement: HTMLElement = document.getElementById('thanks_image_url');
    return (
        <ThemeProvider theme={theme}>
            <div className="step-block">
                <div className={`step-block-circle ${stepNumber1 ? "fill" : ""}`}>
                    1
                </div>
                <hr className="step-block-line" />
                <div className={`step-block-circle ${stepNumber2 ? "fill" : ""}`}>
                    2
                </div>
                <hr className="step-block-line" />
                <div className={`step-block-circle ${stepNumber3 ? "fill" : ""}`}>
                    3
                </div>
            </div>
            <div>
                <div className="point-donation-block">
                    <SupportStatusBlock />
                    <ErrorBlock />
                    {(() => {
                        switch (stepNumber) {
                            case 1: return (<React.Fragment>
                                <div className="center">支援先団体</div>
                                <Select
                                    value={options.find(item => item.value === supportGroup)}
                                    onChange={handleChangeSupportGroup}
                                    placeholder={"支援先を選択"}
                                    id="support_group_value" options={options}></Select>
                                <div className="center point-donation-block-text-small">※支援団体は変更可能です</div>
                            </React.Fragment>);
                            case 2: return (<React.Fragment>
                                <div className="point-donation-form">
                                    <FormControl>
                                        <RadioGroup
                                            defaultValue="manual"
                                            name="use-point-type"
                                            value={pointTypeValue}
                                            onChange={handlePointTypeChange}
                                        >
                                            <div>
                                                <FormControlLabel value="manual" control={<Radio />} label="利用ポイントを入力" />
                                                <TextField
                                                    sx={{ fontSize: "1.5rem" }}
                                                    id="inputSupportPoint"
                                                    type="number"
                                                    label="ポイント数を入力"
                                                    variant={ readOnlyInputSupportPoint ? "filled" : "outlined" }
                                                    value={inputSupportPoint}
                                                    inputProps={{ readOnly: readOnlyInputSupportPoint }}
                                                    onChange={handleInputSupportPointChange}
                                                />
                                                <div style={{color: "red"}}>
                                                    ※半角の数字を入力ください。
                                                </div>
                                            </div>
                                            <div>
                                                <FormControlLabel value="all" control={<Radio />} label="すべてのポイントをつかう" />
                                            </div>
                                        </RadioGroup>
                                    </FormControl>
                                </div>
                            </React.Fragment>);
                            case 3: return (<React.Fragment>
                                <p className="center">
                                    支援・寄付内容の確認<br/>
                                    確定ボタンを押すとポイントで支援・寄付されます。
                                </p>
                            </React.Fragment>);
                            case 4: return (<React.Fragment>
                                <p className="center">
                                    上記内容で支援・寄付いただきました！<br/>
                                    ありがとうございました。
                                </p>
                                <div style={{ display: "flex", justifyContent: "center", marginBottom: "15px" }}>
                                    <div style={{ alignItems: "center" }}>
                                        <img src={thanksImageUrlElement.dataset.value}  alt="" />
                                    </div>
                                </div>
                            </React.Fragment>);
                        }
                    })()}
                </div>
                <div className="point-donation-button-block">
                    {(() => {
                        switch (stepNumber) {
                            case 1: return (<React.Fragment>
                                <button className="point-donation-button" onClick={goToStep2}>
                                    <span>支援・寄付するポイントをきめる</span>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10 6L15.2929 11.2929C15.6834 11.6834 15.6834 12.3166 15.2929 12.7071L10 18" stroke="#FFFFFF" stroke-width="3" stroke-linecap="round"></path>
                                    </svg>
                                </button>
                            </React.Fragment>);
                            case 2: return (<React.Fragment>
                                <div>
                                    <button className="point-donation-button" onClick={goToStep3}>
                                        <span>上記内容で支援・寄付する</span>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10 6L15.2929 11.2929C15.6834 11.6834 15.6834 12.3166 15.2929 12.7071L10 18" stroke="#FFFFFF" stroke-width="3" stroke-linecap="round"></path>
                                        </svg>
                                    </button>
                                </div>
                                <div>
                                    <button className="point-donation-button-back" onClick={goToStep1}>
                                        <span>戻る</span>
                                    </button>
                                </div>
                            </React.Fragment>);
                            case 3: return (<React.Fragment>
                                <div>
                                    <button className="point-donation-button" onClick={executeDonation}>
                                        <span>支援・寄付を確定する</span>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10 6L15.2929 11.2929C15.6834 11.6834 15.6834 12.3166 15.2929 12.7071L10 18" stroke="#FFFFFF" stroke-width="3" stroke-linecap="round"></path>
                                        </svg>
                                    </button>
                                </div>
                                <div>
                                    <button className="point-donation-button-back" onClick={goToStep2}>
                                        <span>戻る</span>
                                    </button>
                                </div>
                            </React.Fragment>);
                        }
                    })()}
                </div>
            </div>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isBlocking}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </ThemeProvider>
    )
}

const container = document.getElementById('app');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<PointDonation />);